import type { ComponentType } from 'react';
import { Avatar as MuiAvatar } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Styled Avatar component with theme integration
 * Uses MUI's native sizing system
 */
export const StyledAvatar = styled(MuiAvatar)(() => ({
  containerType: 'inline-size',
  fontWeight: 500,

  // Ensure text is centered
  '& .MuiAvatar-fallback': {
    width: '100%',
    height: '100%',
  },
})) as typeof MuiAvatar;

/**
 * Wrapper for initials text that responds to container size
 */
export const InitialsWrapper: ComponentType<{ children?: React.ReactNode }> = styled('span')({
  fontSize: '38cqw', // 38% of container (avatar) width
});
